import api from "../axios_service";

export async function listaCobrancasRealizadas(filtros) {
  const response = await api.get(
    `/relatorios/cobrancas-realizadas${filtros ? filtros : ""}`
  );
  return response.data.result;
}